import React, {useEffect, useState} from 'react';
import {ExamQuestion} from "./ExamQuestion";
import {deliverTest} from "../../services/API";
import {TestResult} from "../quiz/TestResult";


export function Exam({test}) {

    const [testAnswers, setTestAnswers] = useState([]);
    const [testResult, setTestResult] = useState(null)

    useEffect(() => {
        if(test != null) {
            setTestAnswers(
                test.questions.map(item => {
                    return {question: item, answers: []}
                })
            )
        }
    }, []);

    function completeTest() {
        deliverTest(5, test.testId, testAnswers).then(result => {
            setTestResult(result)
            console.log(result)
        })
    }

    function testAnswerCallback(index, answers) {
        const copy = [...testAnswers]
        copy[index].answers = answers
        setTestAnswers(copy)
    }

    if(testResult == null && test != null) {
        return (
            <div>

                {
                    test.questions.map((question,idx) => (
                        <ExamQuestion question={question} setTestAnswers={testAnswerCallback} index={idx}/>
                    ))
                }

                <button className={"btn btn-primary text-white w-100 my-3 py-3 border border-dark"} onClick={() => completeTest()}>Lever prøven</button>

            </div>
        );
    } else if(testResult != null) {
        return (<TestResult id={testResult} hideHead={true}/>)
    }

}